let translateUpsell = 0;

let max_width_desktop = 0;
let max_width_mobile = 0;

function scrollPrevUpsell() {
  let container_upsell = document.getElementById("drawer-cart-upsell-products");
  let scroll_upsell_item_width = document.getElementById("drawer-cart-upsell-products").getBoundingClientRect().width;
  let number_of_blocks = parseInt(document.getElementsByClassName("cart-upsell-product").length);

  max_width_desktop = (number_of_blocks - 1) * scroll_upsell_item_width;
  max_width_mobile = (number_of_blocks - 1) * scroll_upsell_item_width;

  if (translateUpsell== 0 && window.screen.width > 768) {
    translateUpsell-= max_width_desktop;
    container_upsell.style.transform = "translateX(" + (translateUpsell) + "px)";
  } 
  else if (translateUpsell== 0 && window.screen.width <=768) {
    translateUpsell-= max_width_mobile;
    container_upsell.style.transform = "translateX(" + (translateUpsell) + "px)";
  }  
  else {
    translateUpsell+= scroll_upsell_item_width;
    container_upsell.style.transform = "translateX(" + translateUpsell+ "px)";
  } 
}

function scrollNextUpsell() {
  let container_upsell = document.getElementById("drawer-cart-upsell-products");
  let scroll_upsell_item_width = document.getElementById("drawer-cart-upsell-products").getBoundingClientRect().width;
  let number_of_blocks = parseInt(document.getElementsByClassName("cart-upsell-product").length);
  max_width_desktop = (number_of_blocks - 1) * scroll_upsell_item_width;
  max_width_mobile = (number_of_blocks - 1) * scroll_upsell_item_width;
  
  if (translateUpsell > -max_width_desktop && window.screen.width > 768) {
    translateUpsell -= scroll_upsell_item_width;
    container_upsell.style.transform = "translateX(" + translateUpsell + "px)";
  }
  else if (translateUpsell > -max_width_mobile && window.screen.width <= 768) {
    translateUpsell -= scroll_upsell_item_width;
    container_upsell.style.transform = "translateX(" + translateUpsell + "px)";
  }
  else {
    translateUpsell = 0;
    container_upsell.style.transform = "translateX(" + translateUpsell + "px)";
  }
}

/* HANDLE SWIPE */
function handleSwipe() {
  let startX = 0;
  let startY = 0;
  let endX = 0;
  let endY = 0;
  let isSwiping = false;

  const carousel = document.getElementById("drawer-cart-upsell-products");

  if (!carousel) {
    return;
  }

  if (carousel.dataset.swipeInitialized === "true") {
    return;
  }

  carousel.dataset.swipeInitialized = "true";

  function onTouchStart(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwiping = false;
  }

  function onTouchMove(e) {
    endX = e.touches[0].clientX;
    endY = e.touches[0].clientY;

    const deltaX = Math.abs(endX - startX);
    const deltaY = Math.abs(endY - startY);

    if (deltaX > deltaY && deltaX > 10) {
      isSwiping = true;
    }
  }

  function onTouchEnd() {
    if (!isSwiping) {
      return;
    }

    const deltaX = endX - startX;

    if (Math.abs(deltaX) > 50) {
      if (deltaX < 0) {
        scrollNextUpsell();
      } else {
        scrollPrevUpsell();
      }
    }

    startX = 0;
    startY = 0;
    endX = 0;
    endY = 0;
    isSwiping = false;
  }

  carousel.addEventListener('touchstart', onTouchStart);
  carousel.addEventListener('touchmove', onTouchMove);
  carousel.addEventListener('touchend', onTouchEnd);
}
/* END HANDLE SWIPE */


/* HANDLE ADD PRODUCT TO CART FROM UPSELL */
function updateCartUpsell() {
  let isMetafield = 'false';
  const elems = document.querySelectorAll('.metafield-checkbox');
  if (elems) {
    elems.forEach((elem) => {
      if (elem.getAttribute('is-metafield') == 'true') {
        isMetafield = 'true';
      }
    })
  }
  if (isMetafield == 'true') {
    return
  }
  const forms = document.querySelectorAll('form[action="/cart/add"]');
  forms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      
      const formData = new FormData(form);
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
          this.cart.renderContents(response);
        })
        .catch((error) => {
          console.error('Error adding product:', error);
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateCartUpsell();
});

const targetElement = document.getElementById('CartDrawer');

if (targetElement) {
  const callback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        updateCartUpsell();
        translateUpsell = 0;

        handleSwipe();
      }
    }
  };

  const observer = new MutationObserver(callback);

  const config = {
    childList: true,
    subtree: true,
  };

  observer.observe(targetElement, config);
}